let selectedBoard = '';
let selectedColor = '';
let selectedLogo = '';
let selectedConstruction = '';
var unlimited_html = '';
let currentFormType = '';
let lastImageState = {};

$('body').addClass('new-order-form-custom');
if (performance.navigation.type == 2) {
  reloadPageIfCartEmpty();
}

function reloadPageIfCartEmpty() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length === 0) {
        location.reload();
      }
    })
    .catch(error => console.error('Error checking cart:', error));
}

$(document).ready(function () {
  unlimited_html = $('.gallery__inner').html();
  waitForElement('#tcustomizer-field-408250-8039731298364', () => {
    waitForFormSelection();
  });
});

function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) {
    callback(el);
  } else {
    const observer = new MutationObserver((_, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        callback(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

function waitForFormSelection() {
  const formSelector = '#tcustomizer-field-408250-8039731298364';
  let customSelectActive = false;

  const checkAndInit = () => {
    const selectedForm = $(`${formSelector} label.tcustomizer-btn--active span`).first().text().trim();

    if (selectedForm === 'Custom Select') {
      if (currentFormType !== 'Custom Select') {
        currentFormType = 'Custom Select';
        $(".gallery__inner").empty(); // ensure unlimited HTML is fully cleared
        initAllObservers();
        lastImageState = {};
        safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
      }
    } else if (selectedForm === 'Custom Unlimited') {
      if (currentFormType !== 'Custom Unlimited') {
        currentFormType = 'Custom Unlimited';
        $(".gallery__inner").html(unlimited_html);
      }
    }
  };

  checkAndInit();

  const observer = new MutationObserver(checkAndInit);
  observer.observe($(formSelector)[0], {
    attributes: true,
    subtree: true,
    childList: true,
  });
}


function initAllObservers() {
  trigger_board_model_change();
  observeConstructionSelection();
  initDesignObserver();
  observeLogoSelection();
}

function trigger_board_model_change() {
  const model_parent_div = document.getElementById('tcustomizer-field-280217-8039731298364');
  if (!model_parent_div) return;

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const targetLabel = mutation.target;
        if ($(targetLabel).hasClass('selected')) {
          const selectedText = $(targetLabel).find('span').first().text().trim();
          selectedBoard = selectedText;
          if (
            !selectedConstruction.toLowerCase().includes("no color") &&
            !selectedConstruction.toLowerCase().includes("dark arts")
          ) {
            selectedColor = '';
          }
          safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
          initDesignObserver(); // Reinit design observer on board change
        }
      }

      if (mutation.type === 'childList') {
        $(mutation.addedNodes).each(function () {
          if (this.nodeType === 1 && this.tagName.toLowerCase() === 'label') {
            observer.observe(this, { attributes: true, attributeFilter: ['class'] });
          }
        });
      }
    });
  });

  $(model_parent_div).find('label').each(function () {
    observer.observe(this, { attributes: true, attributeFilter: ['class'] });
  });

  const preselected = $(model_parent_div).find('label.selected');
  if (preselected.length) {
    const selectedText = preselected.find('span').first().text().trim();
    selectedBoard = selectedText;
    safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
  }

  observer.observe(model_parent_div, {
    attributes: false,
    childList: true,
    subtree: true,
  });
}

function observeConstructionSelection() {
  const constructionFieldSelector = '#tcustomizer-field-965363-8039731298364'; 
  const $constructionField = $(constructionFieldSelector);
  if (!$constructionField.length) return;

  function handleConstructionChange(selectedText) {
    selectedConstruction = selectedText;

    if (selectedConstruction.toLowerCase().includes("no color")) {
      selectedColor = ''; // 👈 standardize
      console.log("Construction = No Color → forcing clear white board");
      safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);

    } else if (selectedConstruction.toLowerCase().includes("dark arts")) {
      selectedColor = 'Jet Black'; // 👈 standardize
      console.log("Construction = Dark Arts → forcing jet black board");
      safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
    } else {
      // Reset observers because Color & Design are active again
      console.log("Construction requires color → reinitializing observers");
      initDesignObserver();
      safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
    }
  }

  // Initial selection
  const initialSelected = $constructionField.find('label.selected .tcustomizer__dropdown-item-value span:first-child').text().trim();
  if (initialSelected) {
    handleConstructionChange(initialSelected);
  }

  const constructionObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const $label = $(mutation.target);
        if ($label.hasClass('selected')) {
          const selectedText = $label.find('.tcustomizer__dropdown-item-value span:first-child').text().trim();
          if (selectedText) {
            handleConstructionChange(selectedText);
          }
        }
      }
    });
  });

  $constructionField.find('label').each(function () {
    constructionObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
  });

  constructionObserver.observe($constructionField.get(0), { childList: true, subtree: true });
}


function initDesignObserver() {
  const designField = '#tcustomizer-field-481633-8039731298364';

  const getAbstractFieldSelector = () => {
    if (selectedBoard.toLowerCase().includes('whaleshark')) {
      return '#tcustomizer-field-492865-8039731298364';
    }
    return '#tcustomizer-field-598724-8039731298364';
  };

  const handleDesignSelection = () => {
    const $active = $(designField).find('label.tcustomizer-btn--active');
    const design = $active.find('span').first().text().trim();

    if (design.startsWith('Single Color')) {
      observeColorOptions('#tcustomizer-field-831018-8039731298364', 'tooltip-text', 'Color');
    } else if (design === 'Abstract (+$350)') {
      const selector = getAbstractFieldSelector();
      observeColorOptions(selector, 'tooltip-text', 'Abstract Option');
    } else if (design === 'Clear') {
      selectedColor = '';
      safeUpdateImage(selectedBoard, '', selectedLogo, selectedConstruction);
    }
  };

  const designObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const $label = $(mutation.target);
        if ($label.hasClass('tcustomizer-btn--active')) {
          handleDesignSelection();
        }
      }
    });
  });

  $(designField).find('label').each(function () {
    designObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
  });

  handleDesignSelection();
}

function observeColorOptions(fieldSelector, tooltipClass, labelName) {
  const $field = $(fieldSelector);
  if (!$field.length) return;

  if (window.colorObserver) {
    window.colorObserver.disconnect();
    window.colorObserver = null;
  }

  const updateColor = () => {
    const selected = $field.find(`.tcustomizer__image--active`)
      .closest('label')
      .find(`.${tooltipClass}`)
      .text()
      .trim();

    if (selected && selectedColor !== selected) {
      selectedColor = selected;
      safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
    }
  };

  updateColor();

  window.colorObserver = new MutationObserver(() => {
    updateColor();
  });

  $field.find('label').each(function () {
    window.colorObserver.observe(this, { attributes: true, attributeFilter: ['class'], subtree: true });
  });
}

function observeLogoSelection() {
  const logoFieldSelector = '#tcustomizer-field-323089-8039731298364';
  const $logoField = $(logoFieldSelector);
  if (!$logoField.length) return;

  const initialSelected = $logoField.find('label.selected .tcustomizer__dropdown-item-value span:first-child').text().trim();
  if (initialSelected) {
    selectedLogo = initialSelected;
    safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
  }

  const logoObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const $label = $(mutation.target);
        if ($label.hasClass('selected')) {
          const selectedText = $label.find('.tcustomizer__dropdown-item-value span:first-child').text().trim();
          if (selectedText) {
            selectedLogo = selectedText;
            safeUpdateImage(selectedBoard, selectedColor, selectedLogo, selectedConstruction);
          }
        }
      }
    });
  });

  $logoField.find('label').each(function () {
    logoObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
  });

  logoObserver.observe($logoField.get(0), { childList: true, subtree: true });
}

function safeUpdateImage(board, color, logo, construction = '') {
  const newState = { board, color, logo, construction };
  // Compare with last state
  if (
    lastImageState.board === newState.board &&
    lastImageState.color === newState.color &&
    lastImageState.logo === newState.logo &&
    lastImageState.construction === newState.construction
  ) {
    // Nothing changed → don’t reload image
    return;
  }

  // Update last state and call image updater
  lastImageState = { ...newState };

  updateMainImage(board, color, logo, construction);
}


function updateMainImage(board, color, logo, construction = '') {

  if (currentFormType === 'Custom Unlimited') {
    console.log("Skipping image update → Custom Unlimited mode");
    return;
  }
  
  const match_board = board.match(/^(.+?)\s+\(\+\$(\d+)\)$/);
  let board_model = '';
  if (match_board) {
    board_model = match_board[1];
  } else {
    board_model = board;
  }

  if (board_model == "D'Boa") {
    board_model = "D-Boa";
  }
  if (board_model == "Whaleshark") {
    board_model = "Whale-shark";
  }
  board_model = board_model.replace(/ /g, '-');

  let board_color = 'Clear-White';
  if (color) {
    board_color = color.replace(/ /g, '-');
    if (board_color == 'Abstract-X') board_color = 'Abstract-White-X';
    else if (board_color == 'Black/White') board_color = 'Abstract-Black-White';
    else if (board_color == 'Pink/Black') board_color = 'Abstract-Pink-Black';
    else if (board_color == 'Red/Black') board_color = 'Abstract-Black-Red';
    else if (board_color == 'Blue/Clear') board_color = 'Abstract-Blue-White';
    else if (board_color == 'Multi/Clear') board_color = 'Abstract-Multi-Blow';
    else if (board_color == 'Bee-Polen') board_color = 'Mustard';
    else if (board_color == 'Pale-Blue') board_color = 'Sky';
    else if (board_color == 'Plum') board_color = 'Pulm';
    else if (board_color == 'Blackberry') board_color = 'BlackBerry';
    else if (board_color == 'Gunmetal-Blue') board_color = 'Gun-Metal';
    else if (board_color == 'Steal-Blue') board_color = 'Steal';

    if (board_model == "Whale-shark") {
      if (board_color == 'Green_White') board_color = 'Green-White';
      else if (board_color == 'Black_White') board_color = 'Black-White';
      else if (board_color == 'Blue_White') board_color = 'Blue-White'; 
    }
  }
   
  let suffix = '-Wholesale'; 
  if (board_model == 'Darkness') suffix = '-Wholesale-New'; 
  if (board_color == 'Clear-White' || board_color == 'Abstract-Black') suffix = '';
  if (board_color == 'Clear-White' && board_model == 'Darkness') suffix = '-Wholesale-New';
  if (board_color == 'Abstract-Black' && board_model == 'Darkness') suffix = '-Wholesale-New';

  var regular_foot_image_arr = ['Proto-A-Typical', 'Bom-Dia', 'Disorder', 'D-Boa', 'Townsend'];
  if (board_color == 'Abstract-Black' && regular_foot_image_arr.includes(board_model)) {
    board_color = 'Regular-Foot-' + board_color;
    suffix = '';
  }

  let filename = board_model + '-' + board_color + suffix;
  let back_fileName = board_model + '-' + board_color + '-Back' + suffix;
  if (construction) {
    const cons = construction.toLowerCase();
    if (cons.includes("eps/flax")) {
      filename = board_model + '-EPS-FLEX';
      back_fileName = board_model + '-Back' + '-EPS-FLEX';
    }
    else if (cons.includes("dark arts")) {
      filename = board_model + '-Dark-Arts';
      back_fileName = board_model + '-Back' + '-Dark-Arts';
    } else if (cons.includes("exo flex")) {
      let is_foot_model= regular_foot_image_arr.includes(board_model) ? '-Regular-Foot' : '';
      filename = board_model + is_foot_model + '-' + 'Clear-White' + '-Exo-Flex';
      back_fileName = board_model + is_foot_model + '-' + 'Clear-White' + '-Exo-Flex' + '-Back' ;
    }
  }
  
  // let imgSrc = 'https://cdn.shopify.com/s/files/1/0605/9861/files/' + filename + '.png?v=1751536243';
  // let back_imgSrc = 'https://cdn.shopify.com/s/files/1/0605/9861/files/' + back_fileName + '.png?v=1751536243';

  const version = Date.now();
  let imgSrc = 'https://cdn.shopify.com/s/files/1/0605/9861/files/' + filename + '.png?v=' + version;
  let back_imgSrc = 'https://cdn.shopify.com/s/files/1/0605/9861/files/' + back_fileName + '.png?v=' + version;

  if (board_model) {
    init_image_design(board_model, imgSrc, back_imgSrc, logo);
  }
}

function init_image_design(board_model = '', front_image = '', back_image = '', logo = '') {
  if (currentFormType === "Custom Unlimited") {
    return;
  }
  if (front_image) {
    var html = '<div class="imgHolder">' +
      '<div class="imgHolderImg front_image">' +
        '<img class="boatImg" alt="" srcset="' + front_image + '">' +
        '<span id="front_logo_holder" class="logo_span"></span>' + 
      '</div>' +
      '<div class="imgHolderImg back_image">' +  
        '<img class="boatImg" alt="" srcset="' + back_image + '">' +
        '<span id="back_logo_holder" class="logo_span"></span>' +
      '</div>' +
    '</div>';
    if ($('.gallery__inner').html().trim() !== html.trim()) {
      $('.gallery__inner').html(html);
    }

    if (logo) {
      console.log('logo: ', logo);
      handle_logo_position(logo, board_model);
    }
  }
}

function handle_logo_position(logo, board_model = '') {
  if (logo) {
    let left_logo = '';
    let right_logo = '';
    if (logo == 'Black X') {
      logo = 'Black-X-Wholesale';
    } else if (logo == 'White X') {
      logo = 'White-X-Wholesale';
    } else if (logo == 'Gold X') {
      logo = 'Gold-X-Wholesale';
    } else if (logo == 'Black Icon') {
      logo = 'Black-Icon-Wholesale';
    } else if (logo == 'White Icon') {
      logo = 'White-Icon-Wholesale';
    } else if (logo == 'Gold Icon') {
      logo = 'Gold-Icon-Wholesale';
    } else if (logo == 'White/Black Block') {
      logo = 'White-Black-Block-Wholesale';
    } else if (logo == 'Black/White Block') {
      logo = 'Black-White-Block-Wholesale';
    } else if (logo == 'Gold/Black Block') {
      logo = 'Gold-Black-Block-Wholesale';
    } else if (logo == 'Gold/White Block') {
      logo = 'Gold-White-Block-Wholesale';
    } else if (logo == 'Clear/White Block') {
      logo = 'Clear-White-Block-Wholesale';
    } else if (logo == 'Black Script') {
      left_logo = 'Black-Script-Left-Wholesale';
      right_logo = 'Black-Script-Right-Wholesale';
      logo = 'Black-Script-Wholesale';
    } else if (logo == 'White Script') {
      left_logo = 'White-Script-Left-Wholesale';
      right_logo = 'White-Script-Right-Wholesale';
      logo = 'White-Script-Wholesale';
    } else if (logo == 'Gold Script') {
      left_logo = 'Gold-Script-Left-Wholesale';
      right_logo = 'Gold-Script-Right-Wholesale';
      logo = 'Gold-Script-Wholesale';
    } else if (logo == 'Black ALBUM') {
      logo = 'Black-Album-Wholesale';
    } else if (logo == 'White ALBUM') {
      logo = 'White-Album-Wholesale';
    } else if (logo == 'Gold ALBUM') {
      logo = 'Gold-Album-Wholesale';
    } else if (logo == 'Black Stack') {
      logo = 'Black-Stack-Wholesale';
    } else if (logo == 'White Stack') {
      logo = 'White-Stack-Wholesale';
    } else if (logo == 'Golden Stack') {
      logo = 'Golden-Stack-Wholesale';
    }

    const logo_url = 'https://cdn.shopify.com/s/files/1/0605/9861/files/'; 
    let front_html = '';
    let back_html = '';
    let front_logo_image = '';
    let back_logo_image = '';
    if (logo.indexOf('Script') != -1) {
      $("#front_logo_holder").addClass('scriptLogo front_logo');
      $("#back_logo_holder").addClass('scriptLogo');
      let style = '';
      let back_style = '';
      if (board_model) {
        if (board_model == 'Warp-Twin') {
          back_style = 'margin-left: -2px;';
        } 
        else if (board_model == 'Proto-A-Typical') {
          back_style = 'margin-left: -1px;';
        }
        else if (board_model == 'Freewing') {
          back_style = 'margin-left: -2px;';
        }
        else if (board_model == 'VB-Secret-Menu') {
          back_style = 'margin-left: 3px;';
        }
        else if (board_model == 'D-Boa') {
          back_style = 'margin-left: 1px;';
        }
      }
      let left_front_logo_image = '<img class="frontLogoImg leftFrontLogoImg" alt="" srcset="' + logo_url + left_logo +'.png?v=1752658728">';
      let right_front_logo_image = '<img class="frontLogoImg rightFrontLogoImg" alt="" srcset="' + logo_url + right_logo +'.png?v=1752658728">';
      back_logo_image = '<img class="backLogoImg" style="'+back_style+'" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      $("#front_logo_holder").html(left_front_logo_image + right_front_logo_image);
      $("#back_logo_holder").html(back_logo_image);
      console.log('logo ', logo);
    } else if (logo.indexOf('Icon')!= -1) {
      $("#front_logo_holder").addClass('iconLogo');
      $("#back_logo_holder").addClass('iconLogo');
      front_logo_image = '<img class="frontLogoImg" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      back_logo_image = '<img class="backLogoImg" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      $("#front_logo_holder").html(front_logo_image);
      $("#back_logo_holder").html(back_logo_image);
      console.log('logo ', logo);
    } else if (logo.indexOf('X')!= -1) {
      $("#front_logo_holder").addClass('xLogo');
      $("#back_logo_holder").addClass('xLogo');
      front_logo_image = '<img class="frontLogoImg" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      back_logo_image = '<img class="backLogoImg" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      $("#front_logo_holder").html(front_logo_image);
      $("#back_logo_holder").html(back_logo_image);
      console.log('logo ', logo);
    } else if (logo.indexOf('Block')!= -1) {
      $("#front_logo_holder").addClass('blockLogo');
      $("#back_logo_holder").addClass('blockLogo');
      front_logo_image = '<img class="frontLogoImg" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      back_logo_image = '<img class="backLogoImg" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      $("#front_logo_holder").html(front_logo_image);
      $("#back_logo_holder").html(back_logo_image);
      console.log('logo ', logo);
    } else if (logo.indexOf('Album')!= -1) {
      $("#front_logo_holder").addClass('albumLogo');
      $("#back_logo_holder").addClass('albumLogo');
      let style = '';
      let back_style = '';
      if (board_model) {
        if (board_model == 'Freewing') {
          back_style = 'margin-left: -3px;';
          style = 'margin-left: -3px;';
        } 
        else if (board_model == 'Proto-A-Typical') {
          back_style = 'margin-left: -3px;';
          style = 'margin-left: 1px;';
        }
        else if (board_model == 'VB-Secret-Menu') {
          back_style = 'margin-left: 2px;';
          style = 'margin-left: 2px;';
        }
        else if (board_model == 'Delma') {
          back_style = 'margin-left: 2px;';
          style = 'margin-left: 4px;';
        }
        else if (board_model == 'D-Boa') {
          back_style = 'margin-left: 2px;';
          style = 'margin-left: 2px;';
        }
        
      }
      front_logo_image = '<img class="frontLogoImg" style="'+style+'" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      back_logo_image = '<img class="backLogoImg" style="'+back_style+'" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      $("#front_logo_holder").html(front_logo_image);
      $("#back_logo_holder").html(back_logo_image);
      console.log('logo ', logo);
    } else if (logo.indexOf('Stack')!= -1) {
      $("#front_logo_holder").addClass('stackLogo');
      $("#back_logo_holder").addClass('stackLogo');
      let style = '';
      let back_style = '';
      if (board_model) {
        if (board_model == 'Freewing') {
          back_style = 'margin-left: -6px;';
          style = 'margin-left: -6px;';
        } 
        else if (board_model == 'Proto-A-Typical') {
          back_style = 'margin-left: -5px;';
          style = 'margin-left: 2px;';
        }
        else if (board_model == 'Warp-Twin') {
          back_style = 'margin-left: -4px;';
          style = 'margin-left: -4px;';
        }
        else if (board_model == 'Twinsman') {
          back_style = 'margin-left: -2px;';
          style = 'margin-left: -2px;';
        }
        else if (board_model == 'The-End') {
          back_style = 'margin-left: 2px;';
          style = 'margin-left: 4px;';
        }
        else if (board_model == 'D-Boa') {
          back_style = 'margin-left: 3px;';
          style = 'margin-left: 3px;';
        }
        else if (board_model == 'Sunstone') {
          back_style = 'margin-left: -2px;';
          style = 'margin-left: -2px;';
        }
      }
      front_logo_image = '<img class="frontLogoImg" style="'+style+'" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      back_logo_image = '<img class="backLogoImg" style="'+back_style+'" alt="" srcset="' + logo_url + logo +'.png?v=1752658728">';
      $("#front_logo_holder").html(front_logo_image);
      $("#back_logo_holder").html(back_logo_image);
      console.log('logo ', logo);
    }
  }
}
